import React, {useCallback, useEffect, useRef, useState} from 'react';
import styles from './SelectionsForm.module.scss';
import {/*finishes, */products} from "components/homePanels/l_customWraps/CustomWraps.data";
import {useDispatch, useSelector} from "react-redux";
import CheckoutModal from "components/homePanels/l_customWraps/checkoutModal/CheckoutModal";
import {buttonClick} from "utils/Helpers";

const SelectionsForm = (props) => {

    const wrapSelection = useSelector(state => state.wrapSelection);
    const accessible = useSelector(state => state.accessible);
    const dispatch = useDispatch();
    const productInput = useRef();
    const modelInput = useRef();
    // const finishInput = useRef();
    const [modelValid, setModelValid] = useState(true);
    // const [finishValid, setFinishValid] = useState(true);
    const [checkoutModal, toggleCheckoutModal] = useState();
    const [error, setError] = useState(null);
    const selectButton = useRef();

    const [list, toggleList] = useState({});

    const checkInputBlur = useCallback((e)=>{
        if(list.product && !productInput.current.contains(e.target)) toggleList({...list, product: false})
        if(list.model && !modelInput.current.contains(e.target)) toggleList({...list, model: false})
        // if(list.finish && !finishInput.current.contains(e.target)) toggleList({...list, finish: false})
    },[list, toggleList]);
    
    useEffect(()=>{
        document.addEventListener('mouseup', checkInputBlur, false);
        return ()=>document.removeEventListener('mouseup', checkInputBlur)
    }, [checkInputBlur])

    function setSelections(value, type){

        props.ddAction();

        let data = {}
        data[type] = value;
        if(type === 'product') data.model = null;

        dispatch({ type: "SET_WRAP_SELECTION",
            payload: {
                ...wrapSelection,
                ...data
            }
        });
    }

    function toggleAction(type, value){

        if((type === 'model' || type === 'product') && !modelValid) setModelValid(true);
        // if(type === 'finish' && !finishValid) setFinishValid(true);

        let set = {...list}
        set[type] = !set[type];
        toggleList(set);
        if(value) setSelections(value, type)
    }

    function generateSku(){
        let productSku = wrapSelection.product && wrapSelection.product.sku ? wrapSelection.product.sku : '';
        let firstSku = wrapSelection.model && wrapSelection.model.sku ? wrapSelection.model.sku : productSku;
        let designSku = wrapSelection.design && wrapSelection.design.sku ? wrapSelection.design.sku : '';
        // let finishSku = wrapSelection.finish && wrapSelection.finish.sku ? wrapSelection.finish.sku : '';

        return firstSku + designSku; // + finishSku
    }

    function submitForm(){

        setError(null);

        /** TODO Validate **/
        let valid = true;
        if(wrapSelection.product && wrapSelection.product.models && !wrapSelection.model){
            valid = false;
            setModelValid(false)
        }

        // if(!wrapSelection.finish){
        //     valid = false;
        //     setFinishValid(false)
        // }

        if(valid) toggleCheckoutModal(true);

    }

    function setErrorData(message){
        setError(message);
    }

    function buildProductList(){
        let list=[];
        products.forEach((p, i) => {
            if(p.name !== wrapSelection.product.name){
                list.push(
                    <div tabIndex={0} key={i} onKeyDown={buttonClick} onClick={()=>toggleAction('product', p)} dangerouslySetInnerHTML={{__html:p.name}}/>
                )
            }
        })
        return list;
    }

    function buildModelList(){
        let list=[];
        wrapSelection.product.models.forEach((m, i) => {
            if(m !== wrapSelection.model){
                list.push(
                    <div tabIndex={0} key={i} onKeyDown={buttonClick} onClick={()=>toggleAction('model', m)} dangerouslySetInnerHTML={{__html:m.name}}/>
                )
            }
        })
        return list;
    }

    // function buildFinishList(){
    //     let list=[];
    //     finishes.forEach((f, i) => {
    //         if(!wrapSelection.finish || f.name !== wrapSelection.finish.name){
    //             list.push(
    //                 <div key={i} onClick={()=>toggleAction('finish', f)} dangerouslySetInnerHTML={{__html:f.name}}/>
    //             )
    //         }
    //     })
    //     return list;
    // }

    function getPreorderWarnning(){
        if(wrapSelection.model && (wrapSelection.model.sku === 'SURFACE-LAPTOP-4-13_KIT_OBD_SKIN_' || wrapSelection.model.sku === 'SURFACE-LAPTOP-4-15_KIT_OBD_SKIN_')){
            return <div className={styles.preOrder}>Pre-order only, shipping late April</div>
        }
    }

    return (
        <div className={styles.productForm}>
            <div className={styles.kicker}>Surface Original</div>
            <h3>{wrapSelection.design.slogan}</h3>
            <p>{wrapSelection.design.subSlogan}</p>
            {wrapSelection.product.notice && <p className={styles.notice}>{wrapSelection.product.notice}</p>}
            <div className={styles.deals}>
                {/*<span className={styles.strike}>${(wrapSelection.product.price / .7).toFixed(2)}</span>&nbsp;*/}
                <span className={styles.big}>${wrapSelection.product.price}</span>&nbsp;
                {/*<span className={styles.box}>30% off</span>*/}
            </div>
            <div className={styles.form}>
                <label>
                    Choose Your Product
                    <div ref={productInput} className={`${styles.inputWrapper} ${list.product ? styles.active : ''}`}>
                        <div tabIndex={0} onKeyDown={buttonClick}
                             aria-label={`You have chosen the product ${wrapSelection.product.name.replace('&nbsp;', ' ')}, click here to change your selection`}
                             className={styles.selected} onClick={()=>toggleAction('product', null)}
                            dangerouslySetInnerHTML={{__html:wrapSelection.product.name}}/>
                        <div className={styles.optionsWrapper}>
                            {list.product && buildProductList()}
                        </div>
                    </div>

                </label>

                {/** Not all products have models **/}
                {wrapSelection.product.models && (
                    <label>
                        Choose Your <span dangerouslySetInnerHTML={{__html:wrapSelection.product.name}}/> Model
                        <div ref={modelInput} className={`${styles.inputWrapper} ${list.model ? styles.active : ''} ${!modelValid ? styles.error : ''}`}>
                            <div tabIndex={0} onKeyDown={buttonClick}
                                 aria-label={wrapSelection.model && wrapSelection.model.name ?
                                     `You have chosen the product model ${wrapSelection.model.name.replace('&nbsp;', ' ')}, click here to change your selection` :
                                     'Click here to choose your model'}
                                 className={styles.selected} onClick={()=>toggleAction('model', null)}>{(wrapSelection.model && wrapSelection.model.name) || 'Choose your model'}</div>
                            <div className={styles.optionsWrapper}>
                                {list.model && wrapSelection.product && buildModelList()}
                            </div>
                        </div>
                        {getPreorderWarnning()}
                        {!modelValid && <div className={styles.errorText}>Please select your device model</div>}

                    </label>
                )}
                {/*<label>*/}
                {/*    Skin Finish*/}
                {/*    <div ref={finishInput} className={`${styles.inputWrapper} ${list.finish ? styles.active : ''} ${!finishValid ? styles.error : ''}`}>*/}
                {/*        <div tabIndex={0} className={styles.selected} onClick={()=>toggleAction('finish', null)}>{(wrapSelection.finish && wrapSelection.finish.name) || 'Select a finish'}</div>*/}
                {/*        <div className={styles.optionsWrapper}>*/}
                {/*            {list.finish && buildFinishList()}*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*    {!finishValid && <div className={styles.errorText}>Please select a finish</div>}*/}
                {/*</label>*/}

                <div ref={selectButton} tabIndex={!accessible.modalOpen ? 0 : -1} role={!accessible.modalOpen ? 'button' : null}  onKeyDown={buttonClick}className={styles.button} onClick={()=>submitForm()}>Add to cart</div>
                <div className={styles.disclaimer}>Complete your purchase through <a href={'https://dbrand.com/designedforsurface'} target={'_blank'} rel={'noreferrer'}>dbrand.com</a>, an authorized seller of Surface skins.</div>
                {error && <div className={styles.errorText}>{error}</div>}
                <img className={styles.msftLogo} src={'https://msobd-storage.azureedge.net/images/customWraps/msft-brand-logo.png'} alt={'Microsoft Logo'}/>
            </div>

            {checkoutModal && <CheckoutModal toggleCheckoutModal={toggleCheckoutModal} sku={generateSku()} setError={setErrorData} refocus={selectButton.current}/>}
        </div>
    )
};

export default SelectionsForm
